import { LeagueTableTabsByDistributionType } from "~/modules/league_tables/types";
import { LeagueTable } from "~/modules/league_tables/components/LeagueTable";
import { useState } from "react";
import { DistributionSelect } from "~/components/DistributionSelect";
import { ColumnSpanConfig, DistributionType, DistributionTypes } from "~/types";
import * as Analytics from "~/modules/league_tables/analytics";

// // // //

export function HomePageLeagueTable(props: {
    title?: string;
    analyticsTableName: string;
    colSpans?: ColumnSpanConfig;
    filterEmptyTabs?: boolean;
    leagueTableTabs: LeagueTableTabsByDistributionType;
}) {
    const {
        title = "RWA League Table",
        analyticsTableName,
        leagueTableTabs,
        filterEmptyTabs,
        colSpans = {
            sm: 12,
            md: 12,
            lg: 12,
            xl: 6,
            xxl: 6,
        },
    } = props;

    // Determine which tabs are available based on the data
    const availableDistributionTypes: DistributionType[] = [];
    const hasDistributedData = leagueTableTabs.distributed.some(
        (t) => t.data.rows.length > 0,
    );
    const hasRepresentedData = leagueTableTabs.represented.some(
        (t) => t.data.rows.length > 0,
    );

    if (hasDistributedData) {
        availableDistributionTypes.push(DistributionTypes.Distributed);
    }
    if (hasRepresentedData) {
        availableDistributionTypes.push(DistributionTypes.Represented);
    }
    if (hasDistributedData && hasRepresentedData) {
        availableDistributionTypes.push(DistributionTypes.All);
    }

    const [transferableFilter, setTransferableFilter] =
        useState<DistributionType>(availableDistributionTypes[0]);

    // Return null if there is no data to show
    if (!hasDistributedData && !hasRepresentedData) {
        return null;
    }

    const tabs = {
        all: leagueTableTabs.all,
        distributed: leagueTableTabs.distributed,
        represented: leagueTableTabs.represented,
    };

    return (
        <LeagueTable
            tabs={tabs[transferableFilter]}
            analyticsTableName={analyticsTableName}
            cardTitle={title}
            filterEmptyTabs={filterEmptyTabs}
            headerChildren={
                <div className="flex gap-3 items-end">
                    <DistributionSelect
                        value={transferableFilter}
                        onChange={(value) => {
                            setTransferableFilter(value);

                            Analytics.trackChangeDistribution({
                                distributionType: value,
                            });
                        }}
                        enabledOptions={{
                            distributed: hasDistributedData,
                            represented: hasRepresentedData,
                        }}
                        includeDescription={false}
                        includeTooltips={true}
                        label={null}
                    />
                </div>
            }
            colSpans={colSpans}
        />
    );
}
